import { render } from "./HeaderWeb.vue?vue&type=template&id=2dca4822"
import script from "./HeaderWeb.vue?vue&type=script&lang=js"
export * from "./HeaderWeb.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/rg-business/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__